export enum UserPreference {
    LAST_ACCESSED_CYCLE = "last_accessed_cycle",
}